import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-title-field',
  templateUrl: './title-field.component.html',
  styleUrls: ['./title-field.component.scss']
})
export class TitleFieldComponent {
  @Input() title: string = 'Page Title';
  @Input() icon: string = '';
  @Input() iconUrl: string = '';
  @Input() iconColor: string = 'currentColor';
  @Input() iconVariant: 'filled' | 'outlined' = 'filled';
  @Input() disabled: boolean = false;
  @Input() showLink: boolean = false;
  @Output() click = new EventEmitter<string>();

  public viewAllIconKey: string = 'open_in_new';
}
